export default __webpack_public_path__ + "static/media/icon-search.f4ee54e5.svg";